import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {clearBitcoinCashout} from '../../../../reducers/app/actions';
import PageLoader from '../../../components/loader_page';

export default ({cashout_request}) => {
    const navigate = useNavigate(), 
          dispatch = useDispatch();

    if(!cashout_request)
        return <PageLoader />;

    return (
        <>
            <div className="alert">
                <div className="icon">
                    ✅
                </div>

                <div className="mt10"></div>
                <div className="title">Bitcoin</div>
                <div className="text">Your <b>${cashout_request.total_amount.usd}</b> withdrawal request has been successfully created and will be processed within 15-30 minutes!</div>
                <div className="text">Expect a transfer to your Bitcoin address <b>{cashout_request.address}</b></div>
                <div className="mt40"></div>

                <div className="big-text">Unique Payment ID: <span className="text-green">{cashout_request.paymentId}</span></div>
            </div>

            <div className="button" onClick={e => {
                dispatch(clearBitcoinCashout());
                navigate('/');
            }}>Okay, thanks!</div>
        </>
    )
}